/**
 * Supported languages. To add one: create src/locales/<code>/common.json (copy `en`),
 * translate it, then add one line here. Nothing else needs to change.
 */
import en from '../locales/en/common.json';

export const LANGUAGES = [
  // English is bundled as the fallback language, so it never needs a separate download.
  { code: 'en', load: () => Promise.resolve({ default: en }) },
  { code: 'ta', load: () => import('../locales/ta/common.json') },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]['code'];
export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export function isLanguageCode(v: unknown): v is LanguageCode {
  return LANGUAGES.some((l) => l.code === v);
}
